import React, { useEffect, useState } from "react";
import { Box, Text, IcoMoon } from "@usap/uicomponents";
const getType = type => {
  switch (type) {
    case "warning":
      return { color: "#FF9700", icon: "info" };
    case "success":
      return { color: "#669944", icon: "check--circle" };

    case "error":
      return { color: "#f44635", icon: "cancel" };
    case "info":
    default:
      return { color: "#4A90E2", icon: "info" };
  }
};

export default function Notification({
  type,
  message,
  timeout = 15000,
  id,
  cb = () => {},
  closable = true,
  textSize = "xsmall"
}) {
  const [show, setShow] = useState(true);
  useEffect(() => {
    if (closable) {
      setTimeout(() => {
        setShow(false);
        cb();
      }, timeout);
    }
  }, []);
  const typeInfo = getType(type);
  if (!show) return "";
  return (
    <Box
      border={{ size: "medium", side: "left", color: typeInfo.color }}
      background="white"
      margin={{ vertical: "small" }}
      id={id}
    >
      <Box
        direction="row"
        align="center"
        pad={{ vertical: "small" }}
        style={{
          borderColor: "#E0E0E0",
          borderStyle: "solid",
          borderWidth: "1px 1px 1px 0"
        }}
      >
        <Box width={"38px"} pad={{ horizontal: "small" }}>
          <IcoMoon size="24px" icon={typeInfo.icon} color={typeInfo.color} />
        </Box>
        <Box width="calc(100% - 60px)">
          <Text size={textSize} dangerouslySetInnerHTML={{ __html: message }} />
        </Box>
      </Box>
    </Box>
  );
}
